export default "__VITE_ASSET__BV9tCv7i__"